import type { MouseEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { ChevronDown } from 'baseui/icon'

const useModuleToggle = (expanded: boolean, onToggle: () => void) => {
  const { t } = useTranslation()

  return {
    Icon: ChevronDown,
    label: t(expanded ? 'common:collapse_module' : 'common:expand_module'),
    // The header row toggles too: without this, one click would fold and unfold at once.
    onClick: (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation()
      onToggle()
    },
  }
}

export default useModuleToggle
